import { useLocation, useNavigate } from 'react-router-dom';

const useCompositionPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);

    const setPage = (page) => {
        params.set("page", page);
        navigate({
            pathname: location.pathname,
            search: params.toString(),
        }, { replace: true });
    }

    return ({ setPage });
}

export default useCompositionPage;